import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store/'
import VueAwesomeSwiper from 'vue-awesome-swiper'
import MintUI from 'mint-ui'
import packageName from '@/utils/packageName'
import VConsole from 'vconsole';

import 'vue-happy-scroll/docs/happy-scroll.css'
import 'mint-ui/lib/style.css'
import './assets/js/rem.js'
import 'swiper/dist/css/swiper.css'
import '@/assets/css/index.less'

Vue.use(VueAwesomeSwiper)
Vue.use(MintUI)

Vue.prototype.packageName = packageName
Vue.config.productionTip = false

//调试工具
var isTest = process.env.VUE_APP_BASE_URL;
if(isTest!='dev' && !location.port){
  new VConsole()
}

new Vue({
  store,
  render: h => h(App),
  router
}).$mount('#app')
